export default __webpack_public_path__ + "static/media/calendarSVG.0d04460f.svg";